import { render, staticRenderFns } from "./CustomerHubActivityDetail.vue?vue&type=template&id=7070ec29&scoped=true"
import script from "./CustomerHubActivityDetail.vue?vue&type=script&lang=js"
export * from "./CustomerHubActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubActivityDetail.vue?vue&type=style&index=0&id=7070ec29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7070ec29",
  null
  
)

export default component.exports